import type { Work } from "@/mocks/works";

interface Props {
  work: Work;
  showStatus?: boolean;
}

export default function WorkCard({ work, showStatus = true }: Props) {
  return (
    <article className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-400/60 transition-all duration-300 hover:-translate-y-1">
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={work.image}
          alt={`${work.title} 韩国免费漫画在线看`}
          title={`${work.title} 高清无遮拦全集`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {showStatus && (
          <span
            className={`absolute top-3 left-3 text-[11px] px-2 py-0.5 rounded-full text-background-50 font-bold ${
              work.status === "已完结" ? "bg-secondary-500" : "bg-accent-500"
            }`}
          >
            {work.status}
          </span>
        )}
        <span className="absolute top-3 right-3 w-9 h-9 rounded-full bg-background-950/80 backdrop-blur flex items-center justify-center text-xs text-accent-500 font-bold">
          {work.rating}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-background-950/90 to-transparent"></div>
        <p className="absolute bottom-2 left-3 right-3 text-[11px] text-foreground-300">{work.update}</p>
      </div>
      <div className="p-3.5">
        <h3 className="font-heading text-sm md:text-base text-foreground-950 leading-snug">{work.title}</h3>
        <p className="mt-0.5 text-[11px] text-foreground-500">{work.korean}</p>
        <div className="mt-2.5 flex flex-wrap items-center gap-1.5">
          <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100/70 text-secondary-500">{work.genre}</span>
          <span className="text-[11px] text-foreground-600">{work.chapters}</span>
        </div>
      </div>
    </article>
  );
}